import { render, staticRenderFns } from "./CreateNewFolderModal.vue?vue&type=template&id=d4fd01fa&"
import script from "./CreateNewFolderModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports